import React, { useState } from "react";

import { ButtonStandard, InputWrapper, ModalBase, SingleSelectInput, Text } from "@performyard/py-components";

export type CsvDownloadType = "review-data" | "goal-discussion";

type DownloadCsvModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onDownload: (csvType: CsvDownloadType) => void;
};

const csvOptions: { label: string; value: CsvDownloadType }[] = [
	{ label: "Review Data CSV", value: "review-data" },
	{ label: "Goal Discussion CSV", value: "goal-discussion" },
];

const DownloadCsvModal = ({ isOpen, onClose, onDownload }: DownloadCsvModalProps) => {
	const [selectedCsvType, setSelectedCsvType] = useState<CsvDownloadType | null>(null);

	const handleClose = () => {
		setSelectedCsvType(null);
		onClose();
	};

	const handleDownload = () => {
		if (!selectedCsvType) return;
		onDownload(selectedCsvType);
		setSelectedCsvType(null);
	};

	return (
		<ModalBase isOpen={isOpen} onClose={handleClose} dangerouslySetClassName="w-[432px] max-w-[90vw]">
			<div className="px-6 pb-4 text-center">
				<Text size="sub-heading" weight="semi-bold">
					Download CSV
				</Text>
			</div>
			<div className="px-6 pb-6">
				<InputWrapper id="download-csv-type" label="Select CSV">
					<SingleSelectInput<CsvDownloadType>
						options={csvOptions}
						value={selectedCsvType ?? undefined}
						onChange={setSelectedCsvType}
						placeholder="Make a selection"
						data-testid="download-csv-type-select"
					/>
				</InputWrapper>
			</div>
			<div className="flex justify-center gap-2 px-6 pb-6">
				<div className="w-fit">
					<ButtonStandard variant="outline" color="neutral" size="large" onClick={handleClose}>
						Cancel
					</ButtonStandard>
				</div>
				<div className="w-fit">
					<ButtonStandard
						color="primary"
						size="large"
						disabled={!selectedCsvType}
						onClick={handleDownload}
						data-testid="download-csv-confirm"
					>
						Download CSV
					</ButtonStandard>
				</div>
			</div>
		</ModalBase>
	);
};

export default DownloadCsvModal;
